export default __webpack_public_path__ + "assets/_Chapters/_Images/background/Ueber-SSV-Kroschke/2.webp";